(function () {
	const animatedText = () => {
		const cards = document.querySelectorAll(".collection-card");

		cards.forEach((card) => {
			card.querySelectorAll(".animated-text").forEach((animatedText) => {
				const text = animatedText.dataset.text;
				animatedText.innerHTML = text
					.split(/(\s+)/)
					.map((chunk) => {
						if (chunk.trim() === "") {
							return '<span class="space">&nbsp;</span>';
						}
						return `<span class="word">${[...chunk]
							.map(
								(letter) =>
									`<span class="letter_wrapper"><span class="letter">${letter}</span></span>`
							)
							.join("")}</span>`;
					})
					.join("");

				const letters = animatedText.querySelectorAll(".letter, .space");

				function addText() {
					card.classList.add("card-animation-active");
					letters.forEach((letter, index) => {
						setTimeout(() => {
							letter.classList.add("visible");
						}, index * 70);
					});
				}

				function removeText() {
					card.classList.remove("card-animation-active");
					letters.forEach((letter, index) => {
						setTimeout(() => {
							letter.classList.remove("visible");
						}, index * 70);
					});
				}

				card.removeEventListener("mouseenter", card.addTextHandler);
				card.removeEventListener("mouseleave", card.removeTextHandler);
				animatedText.addEventListener("focus", card.addTextHandler);
				animatedText.addEventListener("blur", card.removeTextHandler);

				if (window.innerWidth >= 750) {
					card.addTextHandler = addText;
					card.removeTextHandler = removeText;

					card.addEventListener("mouseenter", card.addTextHandler);
					card.addEventListener("mouseleave", card.removeTextHandler);
					animatedText.addEventListener("focus", card.addTextHandler);
					animatedText.addEventListener("blur", card.removeTextHandler);
				}
			});
		});
	};

	const hoverDarkenEffect = () => {
		const gridWrapper = document.querySelector(".collection-grid__wrapper");
		if (!gridWrapper) return;

		const cards = gridWrapper.querySelectorAll(".collection-card");

		cards.forEach((card) => {
			card.addEventListener("mouseenter", () => {
				gridWrapper.classList.add("has-hover");
				card.classList.add("is-hovered");
			});

			card.addEventListener("mouseleave", () => {
				gridWrapper.classList.remove("has-hover");
				card.classList.remove("is-hovered");
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		animatedText();
		hoverDarkenEffect();
		document.addEventListener("shopify:section:load", function () {
			animatedText();
			hoverDarkenEffect();
		});
		window.addEventListener("resize", function () {
			animatedText();
		});
	});
})();